export const FONTS = {
  COMMUTER_SANS: `commuters-sans, sans-serif`,
  INTERSTATE: `Interstate, sans-serif`,
  AVENIR: `Avenir, sans-serif`,
  ROBOTO: `Roboto, sans-serif`,
}
